import React, { useState, useEffect } from 'react';
import temp from '../../temp/config';
import { getPrefixField, sendDmpAction, createFilePath } from '../../utils/obj-utils';
import './style.scss';

export default function index(props) {
  const { fields } = props;
  const [init, setInit] = useState(true);
  let isAutoPause = false;
  return (
    <div className="FullVideo_v2">
      <video
        x5-playsinline="true"
        webkit-playsinline="true"
        playsInline={true}
        className="fullVideo"
        src={createFilePath(fields?.detail_video?.value)}
        autoPlay="autoplay"
        muted={false}
        controls
        // loop
        onPause={() => {
          setTimeout(() => {
            setInit(false);
            if (!isAutoPause) {
              window.Dmp.clickAction(fields?.stop_video_dmp?.value);
            } else {
              isAutoPause = false;
            }
          }, 0);
        }}
        onPlay={() => {
          !init && window.Dmp.clickAction(fields?.play_video_dmp?.value);
        }}
        onEnded={() => {
          isAutoPause = true;
        }}
      />
      <img
        alt="广汽本田"
        className="closeVideo"
        src={createFilePath(fields[getPrefixField('close_icon')].value)}
        onClick={() => {
          props.close();
          window.Dmp.clickAction(fields?.close_icon_dmp?.value, createFilePath(fields?.close_dmp_value?.value));
        }}
      />
    </div>
  );
}
